export const data = [
	{
		spaceType: 'Rack',
		spaceName: 'ATL-DC6-WERTTRTR',
		average: '14.234',
		max: '8.277',
		contracted: '0',
		provisioned: '8',
		capacity: '102',
		startDate: '4/5/2017',
		id: '1',
	},
	{
		spaceType: 'Rack',
		spaceName: 'ATL-DC4-WERTTRTR',
		average: '2.154',
		max: '8.325',
		contracted: '0',
		provisioned: '4',
		capacity: '62',
		startDate: '4/5/2017',
		id: '2',
	},
	{
		spaceType: 'Rack',
		spaceName: 'ATL-DC13-WERTTRTR',
		average: '6.843',
		max: '10.277',
		contracted: '0',
		provisioned: '4',
		capacity: '82',
		startDate: '4/5/2017',
		id: '3',
	},
	{
		spaceType: 'Rack',
		spaceName: 'ATL-DC12-WERTTRTR',
		average: '4.174',
		max: '10.277',
		contracted: '0',
		provisioned: '4',
		capacity: '82',
		startDate: '4/5/2017',
		id: '4',
	},
	{
		spaceType: 'Rack',
		spaceName: 'MYR-DC1-WERTTRTR',
		average: '4.174',
		max: '10.277',
		contracted: '0',
		provisioned: '4',
		capacity: '82',
		startDate: '4/5/2017',
		id: '5',
	},
	{
		spaceType: 'Rack',
		spaceName: 'BHM-DC1-WERTTRTR',
		average: '4.174',
		max: '10.277',
		contracted: '0',
		provisioned: '4',
		capacity: '82',
		startDate: '4/5/2017',
		id: '6',
	},
];
